(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sehr"] && !Shopify.designMode) return;
  try {
    
  // Load YouTube API
  window.onYouTubeIframeAPIReady = function() {
    console.log('YouTube API ready');
  };

  if (!window.YT) {
    const tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    document.head.appendChild(tag);
  }

  class ShrVideoGallery {
    constructor(sectionId) {
      this.container = document.querySelector(`[data-section-id="${sectionId}"]`);
      if (!this.container) return;
      
      this.carousel = this.container.querySelector('.shr-video-carousel');
      this.prevBtn = this.container.querySelector('[data-carousel-prev]');
      this.nextBtn = this.container.querySelector('[data-carousel-next]');
      this.ytPlayers = {};
      
      if (this.carousel && this.prevBtn && this.nextBtn) {
        this.initCarousel();
      }

      this.initAudioControls();
    }

    initCarousel() {
      this.prevBtn.addEventListener('click', () => this.scroll('prev'));
      this.nextBtn.addEventListener('click', () => this.scroll('next'));
    }

    scroll(direction) {
      const scrollAmount = 300;
      if (direction === 'prev') {
        this.carousel.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
      } else {
        this.carousel.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      }
    }

    initAudioControls() {
      // Native controls are now enabled, no custom button needed
      return;
    }

    initYouTubePlayer(iframeId, soundBtn) {
      try {
        const player = new window.YT.Player(iframeId, {
          events: {
            'onReady': (event) => {
              this.ytPlayers[iframeId] = event.target;
              soundBtn.dataset.playerReady = 'true';
            }
          }
        });
      } catch (e) {
        console.log('YouTube player initialization skipped');
      }
    }

    toggleYouTubeVolume(iframeId, soundBtn) {
      try {
        if (this.ytPlayers[iframeId]) {
          const player = this.ytPlayers[iframeId];
          const currentVolume = player.getVolume();
          
          if (currentVolume > 0) {
            player.setVolume(0);
            soundBtn.innerHTML = '🔇';
            soundBtn.classList.remove('unmuted');
            soundBtn.dataset.muted = 'true';
          } else {
            player.setVolume(100);
            player.unMute();
            soundBtn.innerHTML = '🔊';
            soundBtn.classList.add('unmuted');
            soundBtn.dataset.muted = 'false';
          }
        }
      } catch (e) {
        console.log('Volume toggle not available');
      }
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    const sectionId = document.querySelector('[data-section-id]')?.getAttribute('data-section-id');
    if (sectionId) {
      new ShrVideoGallery(sectionId);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
